export enum ForecastingRouteNames {
  FORECASTING_ROOT = 'ForecastingRoot',
  FORECASTING_SHEET = 'ForecastingRoot/ForecastingSheet',
  FORECASTING_TABLE = 'ForecastingRoot/Table',
}
